import React from 'react';
import { Box, Typography, useTheme, Button } from '@mui/material';
import { EventAvailable, Home, Info } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { ROUTE_PATHS } from '../../utils/Routes';

const NoRenewalsCopy: React.FC = () => {
	const theme = useTheme();
	const navigate = useNavigate();

	const isMyPolicy = import.meta.env.REACT_APP_AUTH_REALM === 'MyPolicy';
	const isStreetCover = import.meta.env.REACT_APP_AUTH_REALM === 'StreetCover';

	const getCopy = () => {
		if (isMyPolicy) {
			return (
				<Typography variant='body1' align='center' sx={{ mb: 2 }}>
					If you believe you have a policy due for renewal, please call our customer service team on{' '}
					<Typography component='a' href='tel:03301002337'>
						0330 100 2337
					</Typography>
					.
				</Typography>
			);
		}
		if (isStreetCover) {
			return (
				<Typography variant='body1' align='center' sx={{ mb: 2 }}>
					If you believe you have a policy due for renewal, please call our renewals team on{' '}
					<Typography component='a' href='tel:01704795185'>
						01704 795 185
					</Typography>
					.
				</Typography>
			);
		}
		return (
			<Typography variant='body1' align='center' sx={{ mb: 2 }}>
				If you believe you have a policy due for renewal, please contact our customer service team through the portal or
				call us directly.
			</Typography>
		);
	};

	const copy = getCopy();

	return (
		<Box margin='auto' textAlign='center' alignContent='center' maxWidth='sm'>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					backgroundColor: theme.palette.primary.main + '15',
					borderRadius: '50%',
					p: 2,
					mb: 1,
					width: '100px',
					margin: '0 auto',
				}}
			>
				<EventAvailable
					sx={{
						fontSize: 70,
						color: theme.palette.primary.main,
					}}
				/>
			</Box>

			<Typography
				variant='h5'
				align='center'
				sx={{
					color: theme.palette.primary.main,
					fontWeight: 500,
					mb: 1,
				}}
			>
				No Active Renewals
			</Typography>

			<Typography variant='body1' align='center' sx={{ mb: 2 }}>
				You don&apos;t have any policies due for renewal at this time. We&apos;ll notify you when your next renewal is
				approaching.
			</Typography>

			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 1,
					backgroundColor: theme.palette.info.light + '15',
					p: 2,
					borderRadius: 2,
				}}
			>
				<Info color='info' sx={{ fontSize: '1.2rem' }} />
				<Typography variant='body2' color='text.secondary' textAlign='left'>
					{copy}
				</Typography>
			</Box>

			<Button
				onClick={() => navigate(ROUTE_PATHS.home)}
				variant='outlined'
				color='secondary'
				sx={{ mt: 2, width: '300px' }}
				startIcon={<Home />}
			>
				Go Home
			</Button>
		</Box>
	);
};

export default NoRenewalsCopy;
